import { createSlice } from "@reduxjs/toolkit"

const initialState={
    admin:{
        id: '',
        firstName: '',
        lastName: '',
        email: '',
        role: '',
        profileImage: ''
    }
}

const adminSlice = createSlice({
    name:'admin',
    initialState,
    reducers: {
        setAdmin: (state, action) => {
            state.admin = action.payload
        },
        clearAdmin: (state) => {
            state.admin = initialState.admin
        }
    }
})

export const { setAdmin, clearAdmin } = adminSlice.actions
export default adminSlice.reducer